export const environment = {
  production: false,
  //apiUrl: 'https://broken-night-7120.getsandbox.com',
  apiUrl:'https://63a59f6af8f3f6d4abfb383d.mockapi.io/api-portfolio',
  token: '',
  apiUrlBuffer: '',

  client: '',
  redirectUri: 'http://localhost:4200',
  authority: '',
};
